{
  "actions": {
    "add": "Add",
    "apply": "Apply",
    "back": "Back",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "confirm": "Confirm",
    "continue": "Continue",
    "copy": "Copy",
    "create": "Create",
    "delete": "Delete",
    "done": "Done",
    "download": "Download",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "open": "Open",
    "reload": "Reload",
    "remove": "Remove",
    "rename": "Rename",
    "reset": "Reset",
    "retry": "Retry",
    "save": "Save",
    "search": "Search",
    "send": "Send",
    "tryAgain": "Try again",
    "undo": "Undo",
    "upload": "Upload"
  },
  "status": {
    "loading": "Loading…",
    "saving": "Saving…",
    "saved": "Saved",
    "copied": "Copied",
    "deleting": "Deleting…",
    "uploading": "Uploading…"
  },
  "labels": {
    "untitled": "Untitled",
    "noTitle": "No title",
    "none": "None",
    "name": "Name",
    "email": "Email",
    "search": "Search",
    "settings": "Settings",
    "language": "Language"
  },
  "errors": {
    "generic": "Something went wrong",
    "network": "Connection problem. Check your network and try again."
  }
}
